/**
 * Asynchronously loads the component for GuaranteeSummaryListPage
 */

import { lazyLoad } from 'utils/loadable';

export const GuaranteeSummaryListPage = lazyLoad(
  () => import('./index'),
  module => module.GuaranteeSummaryListPage,
);
